import RepresentationBlock from '../../Representation';

const Representation = ({data}) => {
  const background = data.fullWidth === "yes" ? "add-bg" : "no-bg";

  return (
    <div className={`${background} section__representation`}>
      <RepresentationBlock />
    </div>
  );
};

export default Representation;
